const translations = {
		en: {
			navbarItem: {
				home: "Home",
				about: "About",
				contact: "Contact",
			},
			footer: {
				copyright: "© 2024 Your Company",
				privacy: "Privacy Policy",
				terms: "Terms of Service",
			},
			donationForm: {
				title: "Donation Form",
				name: "Name",
				amount: "Amount",
				message: "Message",
				submit: "Donate",
			},
			contactForm: {
				title: "Contact Form",
				name: "Name",
				email: "Email",
				message: "Message",
				submit: "Send Message",
			},
		},
		mr: {
			navbarItem: {
				home: "मुखपृष्ठ",
				"Daji Maharaj": "श्रीदाजीमहाराज",
				"About Sansthan" : "श्रीदाजीमहाराज संस्थान",
				History: "संस्थानविषयी",
				Parampra: "परंपरा",
				Upkram: "उपक्रम",
				"Varshik Utsav": "वार्षिक उत्सव",
				Janmotsav: "जन्मोत्सव",
				"Chaturmas(Dwadashi Vrat)": "द्वादशी व्रत",
				"Mahashivratra Padyatra": "महाशिवरात्र पदयात्रा",
				Nityopasna: "नित्य उपासना",
				"Bal Sanskar Kendra": "बालसंस्कार केंद्र",
				"Vividh Pooja": "पूजा विधी",
				"Abhishek Pooja": "अभिषेक",
				"Shashwat Pooja": "शाश्वत पूजा",
				"Pavman Pooja": "पवमान पूजा",
				"Guruwar Bhajani Mandal": "गुरुवार भजनी मंडळ",
				"Gangajibapu Maharaj": "श्रीगंगाजीबापूमहाराज",
				Vedpathshala: "वेद पाठशाळा",
				"About Vedpathshala": "वेद पाठशाळा",
				"Admission Process": "प्रवेश प्रक्रिया",
				"Education Details": "अंतर्गत विविध उपक्रम",
				Goshala: "गोशाळा",
				"About Goshala": "गोशाळेची माहिती",
				"Why Goseva": "गोसेवेचे महत्त्व",
				"Seva Mandal": "श्रीदाजीमहाराज सेवामंडळ",
				"Samajik Seva": "सामाजिक सेवा",
				"Paryavaranpurak Upkram": "पर्यावरणास अनुकूल उपक्रम",
				"Sanskrutik Upkram": "सांस्कृतिक उपक्रम",
				"Adhyatmik Upkram": "अध्यात्मिक उपक्रम",
				"Shaishanik Upkram": "शैक्षणिक उपक्रम",
				"Anubhav Kathan": "अनुभव कथन",
				Publication: "प्रकाशन विभाग",
				Blogs: "प्रसंग विशेष",
				"All Blogs": "सर्व प्रसंग विशेष",
				"Donate Now": "देणगी तपशील",
				Gallery: "संग्रहालय",
				"All Gallery": "छायाचित्रदर्शन",
				"All Videos": "व्हिडिओ संग्रह",
				contact: "संपर्क",
			},
			footer: {
				copyright: "copyright २००० श्रीसद्गुरू वेंकटेश दाजीमहाराज संस्थान, धनगर टाकळी",
				privacy: "गोपनीयता धोरण",
				terms: "सेवा अटी",
				contactUs: "संपर्क साधा",
				address: "श्रीसद्गुरू वेंकटेश दाजीमहाराज, धनगर टाकळी",
				popularLinks: "लोकप्रिय दुवे",
				aboutUs: "आमच्याबद्दल",
				upcomingEvents: "आगामी कार्यक्रम",
				latestBlog: "ताज्या ब्लॉग",
				 theDevasthan: "संस्थान"


			},
			donationForm: {
				title: "दान फॉर्म",
				name: "नाव",
				amount: "रक्कम",
				message: "संदेश",
				gotra:"गोत्र",
				email:"ई-मेल",
				phNumber:"फोन नंबर",
				pincode:"पिनकोड क्रमांक",
				state:"राज्य",
				city:"शहर",
				address:"संपूर्ण पत्ता",
				donationType: "देणगी प्रकार",
				"donationType for" : "देणगी प्रकार निवडा",
				"Sub Donation Type": "देणगी उपप्रकार निवडा",
				submit: "submit",
				reset: "reset",
			},
			contactForm: {
				name: "संपूर्ण नाव",
				title: "संपर्क फॉर्म",
				email: "ई-मेल",
				subject: "फोन नंबर",
				message: "संदेश",
				submit: "संदेश पाठवा",
			},
			donateButton:{
				name:"दान"
			}
		},
	};

	export default translations;
